/*
 * Hook do zdania o pochodzeniu danych. Subskrybuje rejestr trybu zrodla, zeby napis
 * odswiezyl sie w chwili, gdy przyjdzie pierwsza odpowiedz z backendu — inaczej ekran
 * pokazywalby zalozenie z konfiguracji budowania do konca zycia strony, mimo ze prawda
 * jest juz znana.
 */
import { useSyncExternalStore } from 'react';
import { opiszZrodlo, subskrybujTrybZrodla, trybZaobserwowany } from '@/lib/trybZrodla';

export function useOpisZrodla(): string {
  return useSyncExternalStore(subskrybujTrybZrodla, opiszZrodlo, opiszZrodlo);
}

export function useTrybZrodla(): ReturnType<typeof trybZaobserwowany> {
  return useSyncExternalStore(subskrybujTrybZrodla, trybZaobserwowany, trybZaobserwowany);
}
